import { render, staticRenderFns } from "./ClearanceCertificate.vue?vue&type=template&id=786fc475&"
import script from "./ClearanceCertificate.vue?vue&type=script&lang=js&"
export * from "./ClearanceCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports